import React, { useContext, useEffect, useState } from "react";
import { GoArrowRight } from "react-icons/go";
import dummyComapyLogo from "../../../../assets/dummyComapyLogo.png";
import { FiAlertCircle } from "react-icons/fi";
import noJobFoundImage from "../../../../assets/Nojob.png";
import { FaLocationDot } from "react-icons/fa6";
import UserContext from "../../../component/ContextApi/UserContext";
import { successPopup } from "../../../../Utils/ToasterMessage";
import { useLocation, useNavigate } from "react-router-dom";
import bagSolid from "../../../../assets/bag-solid.png";
import archiveIcon from "../../../../assets/material-symbols-light_archive-outline.png";
import { URLS } from "../../../../Utils/App_urls";
import Modal from "react-bootstrap/Modal";
import { BsBookmark, BsBookmarkFill } from "react-icons/bs";
import axios from "axios";
import "./JobCards.css";
import { Spinner } from "react-bootstrap";
import { getJobPostedDate } from "../../../../Company/Component/CustomHook/jobPostedDate";
import Pagination from "../../../component/Pagination";
import { BsThreeDots } from "react-icons/bs";
import { IoFilter } from "react-icons/io5";
const NotInterestedIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="#666666"
    stroke="#666666"
    strokeWidth="2.5"
    strokeLinecap="round"
    style={{ marginRight: "5px" }}
  >
    <circle cx="12" cy="12" r="10" />
    <line
      x1="5"
      y1="12"
      x2="19"
      y2="12"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
export default function JobCards({ handleSetFilter }) {
  const { allJobAfterFilter, setAllAfterFilter } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [uniqueIdForSpinner, setUniqueIdForSpinner] = useState("");
  const [notInterestedLoader, setNotInterestedLoader] = useState(false);
  const [saveForLaterLoader, setSaveForLaterLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalJobsCount, setTotalJobsCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("userToken")
  );
  const [topCompaniesLogos, setTopCompaniesLogos] = useState([]);
  const [loadingLogos, setLoadingLogos] = useState(false);
  const [companyJobs, setCompanyJobs] = useState(null);
  const [loadingCompanyJobs, setLoadingCompanyJobs] = useState(false);
  const [companyJobsError, setCompanyJobsError] = useState(false);
  const [sortOption, setSortOption] = useState("");
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [savedJobs, setSavedJobs] = useState([]);
  console.log(location);
  const params = new URLSearchParams(location.search);
  const locationParam = params.get("location");
  const jobCategory = params.get("job-category");
  const industryType = params.get("industry");
  const skills = params.get("skills");
  const experience = params.get("experience");
  const sortOptions = [
    { value: "relevance", label: "Relevance" },
    { value: "date", label: "Date" },
  ];

  const handleClose = (props) => {
    if (props === "login") navigate("/user/login");
    setOpenModal(false);
  };

  const getAllJobs = (pageNo = 1) => {
    const config = {};
    if (isLoggedIn) {
      config.headers = {
        Authorization: `Bearer ${localStorage.getItem("userToken")}`,
      };
    }

    axios
      .get(URLS.getAllJob, {
        ...config,
        params: {
          page: pageNo,
          limit: 20,
          jobLocations: locationParam,
          title: jobCategory,
          industryType: industryType,
          skills: skills,
          experience: experience,
        },
      })
      .then((res) => {
        console.log(res?.data);
        const { result = [], totalPages, page, totalResults = 0 } = res?.data;
        const jobsWithData = result.map((job) => {
          const companyLogo =
            job?.companyProfileDetail?.[0]?.companylogo ||
            topCompaniesLogos.find(
              (c) => c._id === job?.companyProfileDetail?.[0]?.companyId
            )?.logo ||
            dummyComapyLogo;

          return {
            ...job,
            consistentCompanyLogo: companyLogo,
            consistentCompanyName:
              job?.companyProfileDetail?.[0]?.companyName || "N/A",
          };
        });

        setAllAfterFilter(jobsWithData);
        console.log("hello Filter jobs", jobsWithData);
        setTotalPages(totalPages);
        setCurrentPage(page);
        setTotalJobsCount(totalResults);
        if (isLoggedIn) {
          fetchSavedJobs();
        }
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
        setAllAfterFilter([]);
      });
  };

  const fetchSavedJobs = () => {
    axios
      .get(URLS.getSaveLater, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        const savedJobIds = res.data?.data?.map((job) => job.JobId._id) || [];
        setSavedJobs(savedJobIds);
      })
      .catch((err) => {
        console.error("Error fetching saved jobs:", err);
      });
  };

  const handleSortChange = (sortBy) => {
    const sorted = [...allJobAfterFilter];
    if (sortBy === "date")
      sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    else sorted.sort((a, b) => a._id.localeCompare(b._id));
    setAllAfterFilter(sorted);
    setSortOption(sortBy);
    setShowSortDropdown(false);
  };
  const redirectTojobDetails = (id, e) => {
    if (e && (e.target.tagName === "BUTTON" || e.target.closest("button")))
      return;
    if (localStorage.getItem("userToken"))
      navigate(`/user/find-job/job-details/${id}`, { state: { DATA: id } });
    else setOpenModal(true);
  };

  console.log("location", location?.search);

  const handleNotInterestedJob = async (id, e) => {
    e.stopPropagation();
    if (!localStorage.getItem("userToken")) return setOpenModal(true);

    setUniqueIdForSpinner(id);
    setNotInterestedLoader(true);

    try {
      const res = await axios.post(
        URLS.notInterestedJob,
        { JobId: id, status: false },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      successPopup(res.data.message);

      setAllAfterFilter((prevJobs) => prevJobs.filter((job) => job._id !== id));
      setTotalJobsCount((prev) => prev - 1);
    } catch (err) {
      console.error("Error marking job as not interested:", err);
    } finally {
      setNotInterestedLoader(false);
      setUniqueIdForSpinner("");
    }
  };
  const handleSaveForLater = (jobId, e) => {
    e.stopPropagation();
    if (!localStorage.getItem("userToken")) return setOpenModal(true);
    if (savedJobs.includes(jobId)) {
      return successPopup("This job is already saved for later");
    }
    setUniqueIdForSpinner(jobId);
    setSaveForLaterLoader(true);
    axios
      .post(
        URLS.saveLater,
        { JobId: jobId, status: true },
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        successPopup("Job saved for later");
        setSavedJobs((prev) => [...prev, jobId]);
      })
      .catch((err) => console.error("Error saving job:", err))
      .finally(() => setSaveForLaterLoader(false));
  };

  const fetchTopCompaniesLogos = async () => {
    try {
      setLoadingLogos(true);
      const response = await axios.get(URLS.getTopCompaniesLogo, {
        headers: isLoggedIn
          ? {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            }
          : {},
      });
      console.log("image logo for top company", response.data.data);

      const data = response.data?.data || [];
      setTopCompaniesLogos(
        data.map((c) => ({
          _id: c.companyId,
          companyName: c.companyName,
          logo: c.companylogo || dummyComapyLogo,
        }))
      );
    } catch (err) {
      console.error("Error fetching company logos:", err);
      setTopCompaniesLogos([]);
    } finally {
      setLoadingLogos(false);
    }
  };

  const fetchJobsByCompanyId = async (companyId) => {
    if (!isLoggedIn) return;
    try {
      setLoadingCompanyJobs(true);
      setCompanyJobsError(false);
      const res = await axios.get(URLS.getPostsByCompaniyId, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params: { companyId },
      });

      const data = res?.data?.data || [];
      const company = topCompaniesLogos.find((c) => c._id === companyId);

      setCompanyJobs(
        data.map((job) => {
          console.log("Current job:", job);
          return {
            ...job,
            company: job?.company?.companylogo,
            companyName: job?.company?.companyName,
            consistentCompanyLogo:
              job?.companyProfileDetail?.[0]?.companylogo || dummyComapyLogo,
            consistentCompanyName:
              job?.companyProfileDetail?.[0]?.companyName ||
              company?.companyName ||
              "N/A",
          };
        })
      );
    } catch (err) {
      console.error("Error fetching company jobs:", err);
      setCompanyJobsError(true);
      setCompanyJobs([]);
    } finally {
      setLoadingCompanyJobs(false);
    }
  };

  const handleCompanyLogoClick = (companyId) => {
    if (isLoggedIn) fetchJobsByCompanyId(companyId);
    console.log("company id", companyId);
  };

  const resetCompanyJobs = () => {
    setCompanyJobs(null);
    setCompanyJobsError(false);
  };

  const groupCompaniesIntoPairs = () =>
    topCompaniesLogos.reduce((acc, curr, idx) => {
      if (idx % 2 === 0) acc.push([curr]);
      else acc[acc.length - 1].push(curr);
      return acc;
    }, []);

  console.log("allJobAfterFilter", allJobAfterFilter);

  useEffect(() => {
    getAllJobs(currentPage);
  }, [currentPage, locationParam, jobCategory, industryType]);

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("userToken"));
    fetchTopCompaniesLogos();
  }, [isLoggedIn]);

  useEffect(() => {
    getAllJobs(currentPage);
  }, [skills, locationParam, experience]);
  const renderJobs = (jobsArray) =>
    jobsArray.map((job, idx) => (
      <div
        className="job-search-body mb-3 px-1"
        key={job._id || idx}
        onClick={(e) => redirectTojobDetails(job._id, e)}
        style={{ cursor: "pointer" }}
      >
        <div className="job-cards d-flex flex-wrap">
          <div className="job-right-container d-flex flex-column flex-grow-1">
            <div className="job-card-header d-flex align-items-start justify-content-between flex-wrap gap-2">
              <div className="company-title d-flex align-items-start gap-1 mb-2">
                <div className="compay-name">
                  <h1 className="m-0">{job?.title}</h1>
                  <p className="m-0">
                    {job?.companyProfileDetail?.[0]?.companyName}
                  </p>
                </div>
              </div>
              <p className="m-0 d-flex flex-column">
                <div className="company-logo-container">
                  <img
                    src={job?.companyProfileDetail?.[0]?.companylogo}
                    alt={job?.companyProfileDetail?.[0]?.companyName}
                    className="company-logo-img"
                    onError={(e) => {
                      e.target.src = dummyComapyLogo;
                    }}
                  />
                </div>
              </p>
            </div>
            <div className="job-conadtion-box">
              <div>
                <img src={bagSolid} alt="bag" />
                <span>{job.experience}</span>
              </div>
              <div>
                <FaLocationDot size={15} />
                <span>{job.jobLocations}</span>
              </div>
            </div>
            <div className="job-preferences d-flex gap-1 flex-wrap">
              <span>{job.deparmentType}</span>
              <span>{job.workPlace}</span>
              <span>{job.shift}</span>
            </div>
            <div id="formating-typo">
              {job.jobSummary?.slice(0, 200)}
              {job.jobSummary?.length > 200 && "..."}
            </div>
            <div className="company-req-skills d-flex flex-wrap gap-2 gap-sm-3">
              {job.skills?.map((skill, i) => (
                <span key={i}>{skill}</span>
              ))}
            </div>
            <div className="archiveNSavebtn d-flex justify-content-between mt-2">
              <div>
                <small className="sbka-font">
                  {getJobPostedDate(job.createdAt?.split("T"))}
                </small>
              </div>
              <div className="d-flex justify-content-between gap-2 sbka-font">
                <p
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNotInterestedJob(job._id, e);
                  }}
                >
                  {notInterestedLoader && uniqueIdForSpinner === job._id ? (
                    <Spinner
                      style={{
                        width: "15px",
                        height: "15px",
                        borderWidth: "2px",
                        marginRight: "5px",
                      }}
                      animation="border"
                    />
                  ) : (
                    <NotInterestedIcon />
                  )}
                  Not Interested
                </p>
                <p
                  className="text-primary  sbka-font"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSaveForLater(job._id, e);
                  }}
                >
                  {saveForLaterLoader && uniqueIdForSpinner === job._id ? (
                    <Spinner
                      style={{
                        width: "15px",
                        height: "15px",
                        borderWidth: "2px",
                        marginRight: "5px",
                      }}
                      animation="border"
                    />
                  ) : savedJobs.includes(job._id) ? (
                    <BsBookmarkFill
                      style={{ marginRight: "5px", color: "#0d6efd" }}
                    />
                  ) : (
                    <BsBookmark style={{ marginRight: "5px" }} />
                  )}
                  Save for Later
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    <>
      <div className="job-card-container">
        <div className="common">
          <div className="Filter_sort_by">
            {allJobAfterFilter?.length ? (
              <div
                className="d-flex align-items-center justify-content-between"
                style={{
                  width: "100%",
                }}
              >
                <div className="filter_container">
                  <p className="vailable-job-para ">
                    {(() => {
                      const perPage = 20;
                      const start = (currentPage - 1) * perPage + 1;
                      const end = Math.min(
                        currentPage * perPage,
                        totalJobsCount
                      );
                      return `Showing ${start}–${end} of ${totalJobsCount} Jobs`;
                    })()}
                  </p>
                  <span className="dot-filter">
                    <IoFilter onClick={() => handleSetFilter(true)} />
                  </span>
                </div>

                <div className="sort-dropdown-container">
                  <div
                    className="sort-dropdown-header"
                    onClick={() => setShowSortDropdown(!showSortDropdown)}
                  >
                    <span>
                      Sort by:{" "}
                      {sortOptions.find((o) => o.value === sortOption)?.label}
                    </span>
                    <span
                      className={`dropdown-arrow ${
                        showSortDropdown ? "open" : ""
                      }`}
                    >
                      ▼
                    </span>
                  </div>
                  {showSortDropdown && (
                    <div className="sort-dropdown-menu">
                      {sortOptions.map((opt) => (
                        <div
                          key={opt.value}
                          className={`sort-dropdown-item ${
                            sortOption === opt.value ? "active" : ""
                          }`}
                          onClick={() => handleSortChange(opt.value)}
                        >
                          {opt.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* <div className="sort-cont gap-2 align-items-center"> */}
                {/* <div className="sort-dropdown-container">
              <div
                className="sort-dropdown-header"
                onClick={() => setShowSortDropdown(!showSortDropdown)}
              >
                <span>
                  Sort by:{" "}
                  {sortOptions.find((o) => o.value === sortOption)?.label}
                </span>
                <span className="dropdown-arrow">▼</span>
              </div>
              {showSortDropdown && (
                <div className="sort-dropdown-menu">
                  {sortOptions.map((opt) => (
                    <div
                      key={opt.value}
                      className={`sort-dropdown-item ${
                        sortOption === opt.value ? "active" : ""
                      }`}
                      onClick={() => handleSortChange(opt.value)}
                    >
                      {opt.label}
                    </div>
                  ))}
                </div>
              )}
            </div> */}

                {/* {isLoggedIn && (
              <div
                className="parentButtonGrp"
                onClick={() => navigate("/user/notIntested-jobs")}
              >
                <img src={archiveIcon} alt="archiveIcon" />
                <span>Archived Jobs</span>
              </div>
            )} */}
                {/* </div> */}
              </div>
            ) : (
              <div className="no-job-found-container text-center">
                <img
                  src={noJobFoundImage}
                  alt="No jobs found"
                  className="no-job-found-image"
                />
                <h4 className="mt-3">No Job Found!</h4>
                <p className="text-muted">
                  We couldn't find any jobs matching your search criteria. Try
                  adjusting your filters or search terms.
                </p>
              </div>
            )}
          </div>
          <div className="job-cards-wrapper">
            {companyJobs ? (
              <>
                <div className="d-flex show-filter-company align-items-center justify-content-between mb-3">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={resetCompanyJobs}
                  >
                    Back to all jobs
                  </button>
                  <p className="vailable-job-para mb-2">
                    Showing {companyJobs.length} jobs from this company
                  </p>
                </div>
                {loadingCompanyJobs ? (
                  <div className="d-flex justify-content-center my-4">
                    <Spinner animation="border" />
                  </div>
                ) : companyJobsError ? (
                  <div className="alert alert-danger text-center">
                    Failed to load company jobs. Please try again.
                  </div>
                ) : companyJobs.length > 0 ? (
                  renderJobs(companyJobs)
                ) : (
                  <div className="no-job-found-container text-center">
                    <img
                      src={noJobFoundImage}
                      alt="No jobs found"
                      className="no-job-found-image"
                    />
                    <h4 className="mt-3">No Job Found!</h4>
                    <p className="text-muted">
                      We couldn't find any jobs for this company. Try adjusting
                      your search criteria.
                    </p>
                  </div>
                )}
              </>
            ) : (
              allJobAfterFilter?.length > 0 && renderJobs(allJobAfterFilter)
            )}

            {allJobAfterFilter?.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            )}
          </div>
        </div>
        <div className="right-side-box">
          <div className="right-side-content">
            <h3>Sort by Companies</h3>
            {loadingLogos ? (
              <div className="d-flex justify-content-center">
                <Spinner animation="border" />
              </div>
            ) : (
              <div className="company-grid-two-per-row">
                {groupCompaniesIntoPairs().map((pair, ridx) => (
                  <div key={ridx} className="company-row">
                    {pair.map((company, idx) => (
                      <div key={idx} className="company-container">
                        <img
                          src={company.logo}
                          alt={company.companyName}
                          className="company-logo"
                          title={company.companyName}
                          onClick={() => handleCompanyLogoClick(company._id)}
                          style={{
                            cursor: isLoggedIn ? "pointer" : "default",
                          }}
                          onError={(e) => {
                            e.target.src = dummyComapyLogo;
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal */}
      {/* <Modal show={openModal} onHide={() => handleClose("")} centered>
        <Modal.Body className="mdl-bdy d-flex flex-column justify-content-center align-items-center m-3">
          <p className="fs-3 fw-bold mb-4">Kindly Login First!</p>
          <button className="modal-btn" onClick={() => handleClose("login")}>
            Login
          </button>
        </Modal.Body>
      </Modal> */}
      <Modal
        show={openModal}
        onHide={() => handleClose("")}
        centered
        backdrop="static"
        aria-labelledby="login-prompt-modal"
        className="Modal_container m-auto"
      >
        <Modal.Body className="text-center p-4 p-md-5">
          <div className="mb-4">
            <FiAlertCircle className="text-warning" size={48} />{" "}
            {/* Consider adding an icon */}
          </div>
          <h3 className="h4 fw-bold mb-3" id="login-prompt-modal">
            Kindly Login First!
          </h3>
          <p className="text-muted mb-4">
            You need to login to access this feature.
          </p>

          <div className="d-flex gap-3 justify-content-center">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={() => handleClose("")}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary px-4"
              onClick={() => handleClose("login")}
              autoFocus
            >
              Login
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
